

const state = {       
    blocks:[
        {
            id:1,
            name: 'Logos',
            color: '#fff',  
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formmediaupload',
                            attributes: {
                                    placeholder:"Lala",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Zum Logo auswählen klicken",
                                    icon:"backup",
                                    variable:"logo_ids",
                                    setter:'companies/COMPANY_SET_LOGOS',
                                    items:'logos/logos',
                            }                                    
                        }
                    ],                  
                ]
            }            
        }
    ]
 
};

export default {
  namespaced: false,
  state,
  
};